import React from 'react'
import UserLayout from '../../layouts/UserLayout'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import { Avatar, Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { mainGreen, mainRed } from '../../utils/color'

export default function UserProfile() {
	const { currentUser } = useSelector((state) => state.currentUser)
	const navigate = useNavigate()

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
				}}>
				<Card>
					<CardContent>
						{currentUser?.photo ? (
							<Avatar sx={{ mr: 1, width: 120, height: 120 }} alt='avatar' src={currentUser?.photo} />
						) : (
							'Bạn chưa có ảnh đại diện'
						)}
						<Typography sx={{ fontSize: 20, marginBottom: '20px' }} gutterBottom></Typography>
						<Typography sx={{ fontSize: 20, marginBottom: '20px' }} gutterBottom>
							Tên tài khoản: {currentUser?.name}
						</Typography>
						<Typography sx={{ fontSize: 20 }} gutterBottom>
							Email: {currentUser?.email}
						</Typography>
					</CardContent>
					<Box
						sx={{
							mb: 2,
							pl: 1,
							pr: 2,
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'flex-start',
						}}>
						<Button
							onClick={() => {
								navigate('/user/edit-profile')
							}}
							size='small'
							variant='contained'
							sx={{
								background: mainGreen,
								'&:hover': { background: mainGreen },
							}}>
							Chỉnh sửa thông tin
						</Button>
						<Button
							sx={{
								color: mainRed,
								borderColor: mainRed,
								'&:hover': {
									borderColor: mainRed,
								},
							}}
							onClick={() => {
								navigate('/change-password')
							}}
							variant='outlined'
							size='small'>
							Đổi mật khẩu
						</Button>
					</Box>
				</Card>
			</Box>
		</UserLayout>
	)
}
